/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Start_BlankInputs */

const en_us2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from scratch myself`)
};

const pt_br2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar do zero, eu mesmo`)
};

const es_419_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar de cero por mi cuenta`)
};

const pt_pt2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar do zero, eu próprio`)
};

const fr_fr2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partir de zéro moi-même`)
};

const de_de2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbst von vorn bauen`)
};

const it_it2_plan_build_start_blank = /** @type {(inputs: Plan_Build_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parto da zero da solo`)
};

/**
* | output |
* | --- |
* | "Start from scratch myself" |
*
* @param {Plan_Build_Start_BlankInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_start_blank = /** @type {((inputs?: Plan_Build_Start_BlankInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Start_BlankInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_start_blank(inputs)
	if (locale === "es-419") return es_419_plan_build_start_blank(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_start_blank(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_start_blank(inputs)
	if (locale === "de-DE") return de_de2_plan_build_start_blank(inputs)
	if (locale === "it-IT") return it_it2_plan_build_start_blank(inputs)
	return en_us2_plan_build_start_blank(inputs)
});
export { plan_build_start_blank as "plan-build.start_blank" }